'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'leaf-oak';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f6f7';
var svgPathData = 'M224-32c22.6 0 43.1 13.3 52.3 34l13.5 30.3 .6 1.2c1.7 2.5 5 3.6 8 2.6l6.7-2.2 3.8-1.1c19.2-4.9 39.8 .6 54 14.8 18.3 18.3 21.8 46.8 8.5 69.1l-13.9 23.3c-3.2 5.3 .6 12.1 6.8 12.1l28.5 0c30.5 0 55.2 24.7 55.3 55.2 0 18.1-8.9 35.1-23.8 45.4l-58.1 40.2c-5.1 3.5-3.9 11.4 1.9 13.4l20.5 6.8c16.4 5.5 27.4 20.8 27.4 38.1 0 18.2-12.3 34.2-29.9 38.9l-72.2 19c-33.3 8.8-62.3 29.2-81.8 57.5l0 69.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-69.5c-19.5-28.3-48.5-48.7-81.8-57.5L62 390.1c-17.6-4.6-30-20.6-30-38.9 0-17.3 11.1-32.7 27.5-38.1l20.5-6.8 2-1c3.5-2.5 4.2-7.5 1.6-10.9l-1.7-1.5-58.1-40.2C8.9 242.3 0 225.4 0 207.3 0 176.8 24.7 152 55.2 152l28.5 0c6.2 0 10.1-6.8 6.9-12.1l-14-23.3c-13.3-22.2-9.8-50.7 8.5-69.1 15.1-15.1 37.6-20.4 57.9-13.7l6.7 2.2 1.2 .3c3 .4 6-1.2 7.3-4.1L171.7 2 173.5-1.8C183.4-20.3 202.8-32 224-32zm0 16c-14.3 0-27.4 7.3-34.8 19.2l-2.9 5.3-13.4 30.3C168 49.6 155.8 55 144.6 51.3l-6.6-2.2c-14.6-4.8-30.6-1.1-41.5 9.8-13.1 13.1-15.6 33.6-6.1 49.5l14 23.3c9.6 16-1.9 36.3-20.6 36.3l-28.5 0c-21.7 0-39.2 17.6-39.2 39.3 0 12.9 6.3 24.9 16.9 32.2l58.1 40.2 2.8 2.2c11.9 11 9 30.9-5.5 38.1l-3.2 1.4-20.5 6.8c-9.9 3.3-16.5 12.5-16.5 22.9 0 11 7.4 20.6 18 23.4l72.2 19c30.1 7.9 57 24.4 77.7 47.3l0-272.8 .2-1.6c.8-3.6 4-6.4 7.8-6.4s7.1 2.7 7.9 6.4l.1 1.6 0 272.8c20.7-22.8 47.7-39.3 77.8-47.3l72.2-19c10.6-2.8 18-12.4 18-23.4 0-10.4-6.7-19.6-16.5-22.9L363 321.4c-18.4-6.1-21.9-30.7-6-41.7l58.1-40.2c10.6-7.3 16.9-19.4 16.9-32.2 0-21.7-17.6-39.3-39.3-39.3l-28.5 0c-18.6 0-30.2-20.4-20.6-36.3l14-23.3c9.6-15.9 7-36.4-6.1-49.5-10.9-10.8-26.9-14.6-41.4-9.8l-6.7 2.2c-9.8 3.3-20.4-.4-26.2-8.7l-2.1-3.8-13.5-30.3C255.1-6.4 240.3-16 224-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLeafOak = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;